import { NotFound, PageContent, PageHeader, Space } from '@/components';
import { TenantManagerResourceGuard } from '@/features/authentication/_components/TenantManagerResourceGuard';
import { useCreateBreadcrumbs } from '@/hooks/creaet-breadcrumbs';
import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router';
import { ResetPasswordPage } from '../_pages/ResetPasswordPage';
import { UpdateUserButton } from './_components/UpdateUserButton';
import { UserActionsButton } from './_components/UserActionsButton';
import { CreateUserPage } from './_pages/CreateUserPage';
import { UpdateUserPage } from './_pages/UpdateUserPage';
import { UserDetailsPage } from './_pages/UserDetailsPage';

export const UsersRoutes = () => {
  const { t } = useTranslation();
  const { createBreadcrumb } = useCreateBreadcrumbs({ baseIndex: 3 });

  return (
    <Routes>
      <Route
        path="*"
        element={<NotFound showBackButton={false} height="100vh" />}
      />
      <Route
        path="/new"
        element={
          <TenantManagerResourceGuard onlyEdit showDenied>
            <PageHeader
              title={t('create-user-page')}
              breadcrumbs={createBreadcrumb([
                {
                  title: t('tenant-manager-root-page'),
                  href: '/tenant-manager',
                },
                { title: t('create-user-page') },
              ])}
            />
            <PageContent>
              <CreateUserPage />
            </PageContent>
          </TenantManagerResourceGuard>
        }
      />
      <Route
        path="/:id"
        element={
          <>
            <PageHeader
              title={t('user-details-page')}
              breadcrumbs={createBreadcrumb([
                {
                  title: t('tenant-manager-root-page'),
                  href: '/tenant-manager',
                },
                { title: t('user-details-page') },
              ])}
              buttons={
                <TenantManagerResourceGuard onlyEdit>
                  <Space>
                    <UpdateUserButton />
                    <UserActionsButton />
                  </Space>
                </TenantManagerResourceGuard>
              }
            />
            <PageContent>
              <UserDetailsPage />
            </PageContent>
          </>
        }
      />
      <Route
        path="/:id/edit"
        element={
          <TenantManagerResourceGuard onlyEdit showDenied>
            <PageHeader
              title={t('update-user-page')}
              breadcrumbs={createBreadcrumb([
                {
                  title: t('tenant-manager-root-page'),
                  href: '/tenant-manager',
                },
                { title: t('user-details-page') },
                { title: t('update-user-page') },
              ])}
            />
            <PageContent>
              <UpdateUserPage />
            </PageContent>
          </TenantManagerResourceGuard>
        }
      />
      <Route
        path="/:id/reset-password"
        element={
          <TenantManagerResourceGuard onlyEdit showDenied>
            <PageHeader
              title={t('reset-password')}
              breadcrumbs={createBreadcrumb([
                {
                  title: t('tenant-manager-root-page'),
                  href: '/tenant-manager',
                },
                { title: t('user-details-page') },
                { title: t('reset-password') },
              ])}
            />
            <PageContent>
              <ResetPasswordPage />
            </PageContent>
          </TenantManagerResourceGuard>
        }
      />
    </Routes>
  );
};
